const specificationSync = require("specification").SpecificationSync;

const createSpecification = function (isSatisfiedByFunction) {
    let specificationObject = function () {};
    specificationObject.prototype = Object.create(specificationSync);
    specificationObject.prototype.isSatisfiedBy = isSatisfiedByFunction;
    return specificationObject;
};

angular.module("FlexyBeautyApp.services")
    .factory("KycSpecifications", ["LanguageManager", "LegalType", "KycStatusConstants",

        function(LanguageManager, LegalType, KycStatusConstants) {
            let specifications = {};

            specifications.KycSelfCertification = createSpecification(
                () => {
                    return LanguageManager.isFrenchLanguage();
                }
            );

            specifications.SelfContractor = createSpecification(
                (loggedUser) => {
                    return loggedUser.company.legalType === LegalType.SOLETRADER.id;
                }
            );

            specifications.KycCertification = createSpecification(
                (kycLevel) => {
                    return kycLevel === KycStatusConstants.CERTIFIED.key;
                }
            );

            specifications.KycNotCertified = createSpecification(
                (kycLevel) => {
                    return kycLevel === KycStatusConstants.NOT_CERTIFIED.key;
                }
            );

            return specifications;
        }]
    );


// WEBPACK FOOTER //
// ./js/specifications/pro/KycSpecifications.js